require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./workshops-90-minute-prototypes.json") })
        }
      }, "path---workshops-90-minute-prototypes");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---workshops-90-minute-prototypes!./.cache/json/workshops-90-minute-prototypes.json
// module id = 494
// module chunks = 231608221292675